import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./styles.css";
import Loader from "./components/Loader"; // Import the custom loader


// Lazy loading components
const NotificationBar = lazy(() => import("./components/NotificationBar"));
const Navbar = lazy(() => import("./components/Navbar"));
const Footer = lazy(() => import("./components/Footer"));
const RoutesConfig = lazy(() => import("./Routes"));

function AppContent() {
  const location = useLocation();

  // List of routes where Navbar and Footer should be hidden
  const excludedRoutes = ["/buy-now", "/whitepaper"];
  const shouldShowLayout = !excludedRoutes.includes(location.pathname);

  return (
    <div className="App">         
      <Suspense fallback={<Loader />}>
        {/* Render Notification Bar first */}
        {shouldShowLayout && <NotificationBar />}

        {/* Then render the Navbar */}
        {shouldShowLayout && <Navbar />}

        {/* Render routes */}
        <RoutesConfig />

        {/* Render Footer */}
        {shouldShowLayout && <Footer />}
      </Suspense>
    </div>
  );
}

// Wrap everything with BrowserRouter
const Root = () => (
  <BrowserRouter>
    <AppContent />
  </BrowserRouter>
);

export default Root;
